var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddfile = function SvgAddfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 16,
      height: 18,
      margin: 10
    },
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 7.917h4m-2-2v4m3.333 3.333H2.667a1.333 1.333 0 0 1-1.334-1.333V2.583c0-.736.597-1.333 1.334-1.333H6.39c.176 0 .346.07.47.195l3.61 3.61a.67.67 0 0 1 .196.471v6.39c0 .737-.597 1.334-1.334 1.334"
  })));
};
export default SvgAddfile;